// src/lib/utils.ts
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function selectNetwork(currency:string): string {
  switch (currency){
    case "BTC":
      return "BITCOIN";
    case "ETH":
    case "USDT_ERC20":
      return "ETHEREUM";
    case "BNB":
    case "USDT_BEP20":
      return "BSC";
    default:
      return "TRON";
    }  
  }
export function selectTokenType(currency:string): string {
  switch (currency){
    case "BTC":      
    case "ETH":
    case "BNB":
    case "TRX":
      return "NATIVE";
    case "USDT_ERC20":
       return "USDT_ERC20";
    case "USDT_BEP20":
      return "USDT_BEP20";  
    case "USDT_TRC20":
      return "USDT_TRC20";    
    }  
  }
export function selectSymbol(currency:string): string {
  switch (currency){
    case "BTC":   
      return "BTC";   
    case "ETH":
      return "ETH";
    case "BNB":
      return "BNB";
    case "TRX":
      return "TRX";
    case "USDT_ERC20":     
    case "USDT_BEP20":      
    case "USDT_TRC20":
      return "USDT";    
    }  
  }